/**
 * Update a household application submission if it is found in householdApplicationSubmissions array.
 */
export default function updateLocalApplicationSubmission({ state }, { applicationSubmissionId, updates }) {
  const application = state.select([
    'householdApplicationSubmissions',
    ({ id }) => id === applicationSubmissionId,
  ]);

  if (application.exists()) {
    application.merge(updates);
    state.commit();
  }
}
